import styled from 'styled-components';

const ContentHubTeaserCardWrapperContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export default ContentHubTeaserCardWrapperContainer;
